import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import account from './modules/account';
import backupCare from './modules/backupCare';
import job from './modules/job/index';
import sitterOnboarding from './modules/sitterOnboarding';
import { clearCache } from './cache';

Vue.use(Vuex);

clearCache();

const vuexSessionStorage = new VuexPersist({
  key: 'vuex', // display key in the browser session
  storage: window.sessionStorage,
});

const store = new Vuex.Store({
  plugins: [vuexSessionStorage.plugin],
  modules: {
    account,
    backupCare,
    job,
    sitterOnboarding,
  },
});

export default store;
